"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Intersections = void 0;
const three_1 = require("three");
class Intersections {
    constructor() {
        this.raycaster = new three_1.Raycaster();
    }
    getIntersections(mouse, objects, camera, recursive = false) {
        /**
         * Every triangle of every object in the scene is checked if that ray intersects that triangle.
         * If the scene has 1000 objects and each object has 1000 triangles then 1 million triangles need to be checked.
         */
        this.raycaster.setFromCamera(mouse, camera);
        this.raycaster.near = camera.near;
        this.raycaster.far = camera.far;
        const intersections = this.raycaster.intersectObjects(objects, recursive);
        return intersections.length <= 0 ? null : intersections;
    }
}
exports.Intersections = Intersections;
